module.exports = __webpack_public_path__ + "media/images/common/content_h2_bg-15e5e8defb514132daaca7cce159ea89.png";